import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetModuleSpecsQuery } from '../../../api/queries/getModuleSpecs';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import UpdateKycPresetInnerPage from './UpdateKycPresetInnerPage';

const UpdateKYCPresetPage = () => {
    const { moduleId, kycPresetId } = useParams<{ moduleId: string; kycPresetId: string }>();

    const { data, loading } = useGetModuleSpecsQuery({
        fetchPolicy: 'cache-first',
        variables: { moduleId },
    });

    if (!data && !loading) {
        return <NotFoundResult />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    const { module } = data;

    const kycPreset =
        module.__typename === 'LocalCustomerManagementModule'
            ? module.kycPresets.find(item => item.id === kycPresetId)
            : null;

    if (!kycPreset) {
        return <NotFoundResult />;
    }

    return <UpdateKycPresetInnerPage kycPreset={kycPreset} module={module} />;
};

export default UpdateKYCPresetPage;
